<template>
    <div>
        <div id="section-to-print">
           
            <table>
                <tr><td>ឈ្មោះអតិថិជន៖ {{ datas.client_name || "" }}</td></tr>
                <tr><td>លេខទូរស័ព្ទ៖ {{ datas.client_phone || "" || formatPhoneNumber }}</td></tr>
                <tr><td>អាសយដ្ឋាន៖ ភូមិ {{ datas.client_village_name || "" }} ឃុំ {{ datas.client_communce_name || "" }} ស្រុក {{ datas.client_district_name || "" }} ខេត្ត {{ datas.client_province_name || "" }}</td></tr>
                <tr><td>កាលបរិចេ្ឆទ៖ {{ datas.date || "" }}</td></tr>
                <tr><td>លេខវិកយបត្រ៖ {{ datas.reference || "" }}</td></tr>
            </table>

            <table class="border">
                <thead>
                <tr>
                    <th>ល.រ</th>
                    <th>ឈ្មោះទំនិញ</th>
                    <th>ឯកតា</th>
                    <th>ចំនួន</th>
                    <th>តម្លៃ</th>
                    <th>តម្លៃសរុប</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d,i) in datas.transaction_line" :key="i">
                    <td style="text-align: center">{{i+1}}</td>
                    <td>{{d.name}}</td>
                    <td style="text-align: center">{{d.unit_name}}</td>
                    <td style="text-align: center">{{d.qty | formatNumber}}</td>
                    <td style="text-align: right">{{d.price | formatNumber}}{{ d.currency_symbol }}</td>
                    <td style="text-align: right">{{d.sub_total | formatNumber}}{{ d.currency_symbol }}</td>
                </tr>

                <tr>
                    <th colspan="5" style="text-align: right">សរុប</th>
                    <td style="text-align: right">{{datas.total_amount | formatNumber}}{{
                        getCurrencySymbol(datas.currency_code) }}
                    </td>
                </tr>
                <tr>
                    <th colspan="5" style="text-align: right">បានបង់</th>
                    <td style="text-align: right">{{datas.paid_amount | formatNumber}}{{
                        getCurrencySymbol(datas.currency_code) }}
                    </td>
                </tr>
                <tr>
                    <th colspan="5" style="text-align: right">នៅសល់</th>
                    <td style="text-align: right">{{(parseFloat(datas.total_amount)-parseFloat(datas.paid_amount || 0)) | formatNumber}}{{
                        getCurrencySymbol(datas.currency_code) }}
                    </td>
                </tr>
                </tbody>
            </table>


         
        </div>


    </div>

</template>

<script>
    import {provider} from "@/service/provider";
    import axios from "axios";
    import moment from "moment";
    import MainMixin from "../../../mixins/mainMixin"

    export default {
        mixins: [MainMixin],
        data() {
            return {
                transaction_id: '',
                today         :moment().format("YYYYMMDD"),
                datas: {},
            }
        },
        methods: {
            handlePrint(event) {
                event.preventDefault();
                window.print();
            },

            handleRun() {
                 if(this.transaction_id){
                    let vm      = this;
                    let url     = provider.baseURL + provider.getTransactionReconcileInvoice;
                    let params  = {
                        search          : '',
                        contact_id      : this.$store.state.reconcile.client_id,
                        id              : this.transaction_id,
                        offset          : 0,
                        sort_by         : "created_at",
                        sort_desc       : 0 ,
                        limit           : 1,
                        date_from       : '',
                        date_to         :''
                    };

                    axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(res => {
                    if (res.data.response && res.data.response.code === 200) {

                        let data = res.data.data[0];
                        vm.datas = data;
                        vm.$nextTick(() => { window.print(); });
                        vm.$nextTick(() => { this.$router.back(); });
                    }
                    }).catch(error => console.log(error));
                 }
                 else{
                    this.$router.back();
                 }
            }
        },
       
        mounted(){ this.handleRun() },
        created() { this.transaction_id = this.$route.params.id; }
    }
</script>